import { useApp } from "../app-context.tsx";
import { useFitDirectory } from "../fits.ts";

/** Fewest tagged sets before the home page says how many there are (a young community shouldn't look empty). */
export const PROOF_MIN_FITS = 10;

/**
 * Under the home search: how it works in three steps, what it costs (and
 * whether downloading needs sign-in), and, once there are enough, how many
 * sets the community has tagged (from the fit directory the search already loads).
 */
export function HowItWorks() {
  const { brand, copy, auth, locale } = useApp();
  const fits = useFitDirectory().data?.fits.length ?? 0;
  const signInToDownload = brand.config.features.exportRequiresSignIn && auth.enabled;
  return (
    <div className="home-how">
      <ol className="home-steps" aria-label={copy("home.howLabel")}>
        {(["home.step1", "home.step2", "home.step3"] as const).map((k, i) => (
          <li key={k}>
            <span className="home-step-n" aria-hidden>
              {i + 1}
            </span>
            {copy(k)}
          </li>
        ))}
      </ol>
      <p className="home-how-sub">{copy(signInToDownload ? "home.freeSignIn" : "home.free")}</p>
      {fits >= PROOF_MIN_FITS && <p className="home-proof">{copy("home.proof", { count: fits.toLocaleString(locale) })}</p>}
    </div>
  );
}
